export enum AnalyticsKey {
  HEADER = 'header',
  CENTER_FIRST = 'center_first',
  CENTER_SECOND = 'center_second',
  CENTER_THIRD = 'center_third',
  CENTER_FOURTH = 'center_fourth',
  CENTER_FIFTH = 'center_fifth',
  CENTER_SIXTH = 'center_sixth',
  CENTER_SEVENTH = 'center_seventh',
  CENTER_EIGHTH = 'center_eighth',
  CENTER_NINTH = 'center_ninth',
  CENTER_TENTH = 'center_tenth',
  CENTER_ELEVENTH = 'center_eleventh',
  CENTER_TWELFTH = 'center_twelfth',
  CENTER_THIRTEENTH = 'center_thirteenth',
  CENTER_FOURTEENTH = 'center_fourteenth',
  CENTER_FIFTEENTH = 'center_fifteenth',
  FOOTER = 'footer',
}

export type ReportTrackingParams = {
  screenContext?: string;
  analyticsKey?: AnalyticsKey;
  offerId?: string;
  trigger?: string;
  isScrolledToDisclaimer?: boolean;
};
